import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Form, ListGroup, Row ,Card,CloseButton,FloatingLabel,InputGroup,FormControl, Tabs, Tab,Image,Modal,Table } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router';
//import { Link } from 'react-router-dom';

//import qs from 'qs';
//import styled from 'styled-components';
//import { getCurrentDate,getCurrentTime,getSundayList } from './component/MyUtils';
import { getUserSession } from '../component/userInfo';
/*
const MyInput = styled.div`
.weekly-input {
  position: relative;
  padding: 1rem;
  border: .2rem solid #ececec;
  border-radius: 8px;
  margin-right: 0;
  margin-left: 0;
  color: #212529;
}
.content-type {
   border : 1px solid #ced4da;
   padding: 1rem 0.75rem;
   position: relative;
   display: flex;
   border-radius: 0.25rem;
}
.content-type>label  {
   opacity: .65;
   transform: scale(.85) translateY(-0.5rem) translateX(0.15rem); 
   position: absolute;
   top: 0;
   left: 0;
   height: 100%;
   padding: 1rem 0.75rem;
   pointer-events: none;
   border: 1px solid transparent;
   transform-origin: 0 0;
}
.content-border {
    border : 1px solid #ced4da;
    border-radius: 0.25rem;
 }
 `
;
*/
const VideoInputForm = (props) => {
     //{youtubeInfo,serverInfo,show} = props;

 
    const [categoryList, setCategoryList] = useState();
    const [categoryNo, setCategoryNo] = useState();

    useEffect(() => {
        fetchCategoryList();
    }, []);
    const fetchCategoryList = async () => {
        const userSession = getUserSession();
        try{
            const formData = new FormData();
            formData.append('uid', userSession.uid);
            formData.append('action', 'categoryList');
            let res = await fetch('https://work.wekoinonia.org/json/video.php', {
                method: 'POST',
                body: formData,
            });
            
            let json = await res.json(); //Promise 반환
            console.log(json); // 서버에서 주는 json데이터가 출력 됨 
            if(json.list){
                setCategoryList(json.list);
            }
          } catch(error) { 
            console.error('Error:', error)
          }
       }
    useEffect(() => {
     console.log("VideoInputForm useEffect >>>>>>>>>",props);

      //setShow(props.videoInfo ? props.videoInfo.show : false);
    }, []);
    useEffect(() => {
      console.log("VideoInputForm useEffect >>>>>>>>>",props);
      setCategoryNo(props.videoCategoryNo);
       //setShow(props.videoInfo ? props.videoInfo.show : false);
     }, []);
    console.log("VideoInputForm >>>>>>>>>",props);
   //setShow(props.videoInfo ? props.videoInfo.show : false);

    const saveVideoOnClick = (event)  =>{
      event.preventDefault();
      let youtubeItem = props.videoInfo.youtubeInfo;
      youtubeItem.videoCategoryNo = props.videoCategoryNo; // id=categoryNo를 가져오는 걸 생각할 것 
      console.log("saveVideoOnClick ",youtubeItem)
      props.saveVideo(youtubeItem);
      props.close();

    } 
    return (
      <Modal show={props.videoInfo.show} 
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => props.close()}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            유튜브 동영상 등록
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h4>등록</h4> */}
              <Form>
                <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>메뉴</Form.Label>
                    <Form.Select id="categoryNo" value={categoryNo} onChange={ e => {setCategoryNo(e.target.value)}}>
                        {categoryList && categoryList.map( (item,index) => { return (                            
                            <option value={item.video_category_no} key={index}>{item.video_category_name}</option>
                        )})}
                    </Form.Select>
                  </Form.Group>
                </Col>

                </Row>
                <fieldset disabled>
                </fieldset>
              </Form>
              <Table striped bordered hover>
                {/* <thead>
                  <tr>
                    <th>필드명</th>
                    <th>우리홈피</th>
                    <th>유튜브</th>
                  </tr> 
                </thead>*/}
                <tbody>
                  <tr>
                    <td>우리홈피</td>
                    <td  colSpan={2}>{props.videoInfo.serverInfo.info &&  props.videoInfo.serverInfo.info.video_title}</td>
                  </tr>
                  <tr>
                    <td>유튜브</td>
                    <td  colSpan={2}>{props.videoInfo.youtubeInfo &&  props.videoInfo.youtubeInfo.videoTitle}</td>
                  </tr>
                  {/* <tr>
                    <td>설명</td>
                    <td>{props.videoInfo.serverInfo.info.video_desc}</td>
                    <td>{props.videoInfo.youtubeInfo.items[0].snippet.description}</td>
                  </tr> */}
                </tbody>
              </Table>              
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.close}>Close</Button>
          <Button onClick={ e => {saveVideoOnClick(e)}} variant="primary" >
            Save Changes
          </Button>

        </Modal.Footer>
      </Modal>
    );
}


export default VideoInputForm;
/*
{youtubeInfo: {…}, serverInfo: {…}, show: true}serverInfo: code: "0000"info: channel_id: "UCS0IUuIpGA5GF5NBZfnJkaQ"creaton_time: "2022-04-17 23:26:22"creator: "eLXNIDUK5Fesnze2bXhAXmris023"img_crop_class: ""playlist_id: "PLxmOPUWuFmv813g3ImxKrB0HZEX3JHYVF"published: "2022-04-17T13:59:24Z"use_yn: "Y"video_category_name: "예배영상"video_category_no: "1"video_desc: "2022-04-17<br />\r\n사귐의교회 주일설교<br />\r\n예수께서 오신다 (마태복음 14장 22-33절)<br />\r\n유병휘 목사<br />\r\n<br />\r\n▒▒▒　사귐의교회 예배 안내　▒▒▒<br />\r\n- 주일 예배 : 오전 9시(1부), 오전 11시 30분(2부), 오후 2시(3부)<br />\r\n- 수요 예배 : 오후 7시 30분 <br />\r\n- 예배 장소 : 서울종합예술실용학교 아리랑홀(서울시 강남구 테헤란로 505)<br />\r\n- 새벽 예배 : 매일(월-토) 오전 5시 30분<br />\r\n  (새벽 예배는 온라인으로만 진행합니다)<br />\r\n<br />\r\n▒▒▒　사귐의교회 홈페이지 안내　▒▒▒<br />\r\n- 사귐의교회 홈페이지 : https://www.wekoinonia.org<br />\r\n- 사귐의교회 카카오톡 : https://pf.kakao.com/_Ckfxgs<br />\r\n (카카오톡 채널을 추가하시면 관련 소식을 받으실 수 있습니다)<br />\r\n<br />\r\n▒▒▒　온라인 헌금 안내　▒▒▒<br />\r\n- 교회의 고유번호가 나올 때까지, 아래의 계좌를 임시로 사용합니다.<br />\r\n- 국민 294501-04-169664 유병휘"video_id: "jgyUjq_sH8U"video_img_src: "https://i.ytimg.com/vi/jgyUjq_sH8U/default.jpg"video_no: "24"video_title: "2022년 4월 17일 주일설교 | 예수께서 오신다 | 유병휘 목사 | 사귐의교회"[[Prototype]]: Objectmsg: ""[[Prototype]]: Objectshow: trueyoutubeInfo: etag: "6x8SGYkNntBFTxr7wHzjAeRlwLQ"items: Array(1)0: etag: "9bvL1AQinj5IDaJ-X-WroEa72ms"id: "jgyUjq_sH8U"kind: "youtube#video"snippet: categoryId: "27"channelId: "UCS0IUuIpGA5GF5NBZfnJkaQ"channelTitle: "사귐의교회"description: "2022-04-17\n사귐의교회 주일설교\n예수께서 오신다 (마태복음 14장 22-33절)\n유병휘 목사\n\n▒▒▒　사귐의교회 예배 안내　▒▒▒\n- 주일 예배 : 오전 9시(1부), 오전 11시 30분(2부), 오후 2시(3부)\n- 수요 예배 : 오후 7시 30분 \n- 예배 장소 : 서울종합예술실용학교 아리랑홀(서울시 강남구 테헤란로 505)\n- 새벽 예배 : 매일(월-토) 오전 5시 30분\n  (새벽 예배는 온라인으로만 진행합니다)\n\n▒▒▒　사귐의교회 홈페이지 안내　▒▒▒\n- 사귐의교회 홈페이지 : https://www.wekoinonia.org\n- 사귐의교회 카카오톡 : https://pf.kakao.com/_Ckfxgs\n (카카오톡 채널을 추가하시면 관련 소식을 받으실 수 있습니다)\n\n▒▒▒　온라인 헌금 안내　▒▒▒\n- 교회의 고유번호가 나올 때까지, 아래의 계좌를 임시로 사용합니다.\n- 국민 294501-04-169664 유병휘"liveBroadcastContent: "none"localized: {title: '2022년 4월 17일 주일설교 | 예수께서 오신다 | 유병휘 목사 | 사귐의교회', description: '2022-04-17\n사귐의교회 주일설교\n예수께서 오신다 (마태복음 14장 22-33절)\n유…때까지, 아래의 계좌를 임시로 사용합니다.\n- 국민 294501-04-169664 유병휘'}publishedAt: "2022-04-17T11:46:31Z"thumbnails: {default: {…}, medium: {…}, high: {…}}title: "2022년 4월 17일 주일설교 | 예수께서 오신다 | 유병휘 목사 | 사귐의교회"[[Prototype]]: Object[[Prototype]]: Objectlength: 1[[Prototype]]: Array(0)kind: "youtube#videoListResponse"pageInfo: {totalResults: 1, resultsPerPage: 1}[[Prototype]]: Object[[Prototype]]: Object
*/